<template>
  <v-footer dark class="app app-bar">
    <v-row justify="center" align="center">
      <v-col cols="auto" class="d-flex align-center">
        <span class="mr-2">Powered By</span>
        <a
          href="https://edupluscampus.com/"
          target="_blank"
          style="display: inline-flex; align-items: center"
        >
          <v-img
            height="20"
            width="60"
            contain
            alt="EduplusCampus Logo"
            src="https://www.edupluscampus.com/img/logos/1.png"
          ></v-img>
        </a>
        <a
          href="https://www.youtube.com/channel/UCisFmSqTOFXMcpb7GlmE_7A/playlists"
          target="_blank"
          class="ml-3 icon linkedIn"
        >
          <v-icon color="#FF0000">mdi-youtube</v-icon>
        </a>
        <a
          href="https://www.facebook.com/edutech4?utm_source=Facebook_Page&utm_medium=leads&utm_campaign=edu_Facebook"
          target="_blank"
          class="ml-3 icon linkedIn"
        >
          <v-icon color="#0A66C2">mdi-facebook</v-icon>
        </a>
        <a
          href="https://bit.ly/3l5elKE"
          target="_blank"
          class="ml-3 linkedIn icon"
        >
          <v-icon class="instagram">mdi-instagram</v-icon>
        </a>
        <a
          href="https://bit.ly/3l4ZGiu"
          target="_blank"
          class="ml-3 icon linkedIn"
        >
          <v-icon color="#0A66C2">mdi-twitter</v-icon>
        </a>
        <a
          href="https://bit.ly/3bBTdsA"
          target="_blank"
          class="ml-3 icon linkedIn"
        >
          <v-icon color="#0A66C2">mdi-linkedin</v-icon>
        </a>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
import { version } from "../../package.json";
export default {
  data() {
    return {
      ver: "",
    };
  },
  created() {
    this.ver = version;
  },
};
</script>
<style scoped>
.app {
  background: #3949ab; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3949ab,
    #3949ab,
    #3949ab
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #3949ab,
    #3949ab,
    #3949ab
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
@media (max-width: 920px) {
  body {
    overflow-x: hidden;
    width: 100%;
  }

  .app-bar {
    /* height: 70px !important; */
    width: 100% !important;
  }
  .footer-btn {
    text-transform: none;
    font-size: 12px !important;
    display: block;
    word-wrap: break-word;
  }
  .company-name {
    /* color: red; */
    white-space: normal;
  }
}
.footer-btn {
  text-transform: none;
  font-size: 12px;
}
.linkedIn {
  padding: 2px 2px;
  border-radius: 10px;
  font-size: 17px;
  background: #ffffff;
  display: inline-block;
  text-align: center;
}
.instagram {
  background: #d6249f;
  border-radius: 10px;
  padding: 1px;
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
}
.icon {
  text-decoration: none;
  color: #ffffff;
}
</style>